export default {
  "pl": {
    "navbar": {
      "customer": {
        "dashboard": "Panel główny",
        "decisions": "Decyzje",
        "documents": "Dokumenty",
        "inspirations": "Inspiracje",
        "installments": "Dane finansowe",
        "profile": "Twój profil",
        "projectinfo": "Informacje",
        "question_lists": "FAQ",
        "surveys": "Ankiety",
        "ticket": {
          "new": "Nowa rozmowa"
        },
        "tickets": "Rozmowy",
        "units": "Plik powykonawczy"
      },
      "employee": {
        "client": "{client} – profil",
        "contacts": "Kontakty",
        "customer": "Klient",
        "dashboard": "Panel główny",
        "employee": "Członek zespołu",
        "partner": "Partner",
        "profile": "Twój profil",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Decyzje",
          "documents": "Dokumenty",
          "info": "Informacje",
          "installments": "Dane finansowe",
          "news": "Aktualności",
          "question_lists": "FAQ",
          "surveys": "Ankiety",
          "todos": "Zadania"
        },
        "projects": "Projekty",
        "ticket": {
          "new": "Nowa rozmowa"
        },
        "tickets": "Rozmowy"
      },
      "partner": {
        "contacts": "Kontakty",
        "dashboard": "Panel główny",
        "profile": "Twój profil",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Decyzje",
          "documents": "Dokumenty",
          "tickets": "Rozmowy"
        },
        "projects": "Projekty"
      },
      "topnavbar": {
        "company": "Firma",
        "helpcenter": "Centrum pomocy",
        "logout": "Wyloguj się",
        "profile": "Profil",
        "selectTeam": "Wybierz firmę"
      }
    }
  }
}
